import axios from '../api';

export function login(email, password, remember = false) {
  return new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_API_AUTH_BASE_URL + 'api/login', {
        email,
        password,
        remember,
      })
      .then(function (response) {
        return resolve(response.data);
      })
      .catch(reject);
  });
}

export function logout() {
  return new Promise((resolve, reject) => {
    axios
      .post(process.env.REACT_APP_API_AUTH_BASE_URL + 'api/logout')
      .then(resolve)
      .catch(reject);
  });
}

export function getUserData() {
  return new Promise((resolve, reject) => {
    axios
      .get(
        'me?include=permissions,companies,companies.registrations,companies.registrations.event,companies.registrations.event.periods'
      )
      .then(function (response) {
        return resolve(response.data);
      })
      .catch(function (error) {
        return reject(error);
      });
  });
}

export function fetchCsrfToken() {
  return new Promise((resolve, reject) => {
    axios
      .get('csrf-cookie')
      .then(function (response) {
        return resolve(response.data);
      })
      .catch(function (error) {
        return reject(error);
      });
  });
}

export async function updatePassword(id, values) {
  const { data } = await axios.post('users/' + id + '/password', values);
  return data;
}

export async function enableTwoFactorAuthentication(password) {
  return await axios.post(process.env.REACT_APP_API_AUTH_BASE_URL + 'api/user/two-factor-authentication');
}

export async function disableTwoFactorAuthentication() {
  return await axios.delete(process.env.REACT_APP_API_AUTH_BASE_URL + 'api/user/two-factor-authentication');
}

export async function getTwoFactorQrCode() {
  const response = await axios.get(process.env.REACT_APP_API_AUTH_BASE_URL + 'api/user/two-factor-qr-code');

  return response.data;
}

export async function confirmTwoFactorAuthentication(code) {
  return await axios.post(process.env.REACT_APP_API_AUTH_BASE_URL + 'api/user/confirmed-two-factor-authentication', {
    code,
  });
}

export async function twoFactorAuthentication(data) {
  return await axios.post(process.env.REACT_APP_API_AUTH_BASE_URL + 'api/two-factor-challenge', data);
}

export async function getRecoveryCodes() {
  return await axios.get(process.env.REACT_APP_API_AUTH_BASE_URL + 'api/user/two-factor-recovery-codes');
}
